export const WATERJUG = "WATERJUG";
export const WATERJUG_SUCCESS = "WATERJUG_SUCCESS";
export const WATERJUG_FAILED = "WATERJUG_FAILED";

export const ADD_WATERJUG = "ADD_WATERJUG";
export const ADD_WATERJUG_SUCCESS = "ADD_WATERJUG_SUCCESS";
export const ADD_WATERJUG_FAILED = "ADD_WATERJUG_FAILED";

export const UPDATE_WATERJUG = "UPDATE_WATERJUG";
export const UPDATE_WATERJUG_SUCCESS = "UPDATE_WATERJUG_SUCCESS";
export const UPDATE_WATERJUG_FAILED = "UPDATE_WATERJUG_FAILED";